/**
 * Uses Swiper to create a carousel for testimonials.
 */
class TestimonialsNewSlider extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      pagination: '[data-pagination]',
      readMore: '[data-read-more]',
      readMoreButton: '[data-read-more-button]',
      readMoreContent: '[data-read-more-content]',
    };

    const donutDot = this.dataset.donutDot;
    const donutDotActive = this.dataset.donutDotActive;

    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
        pagination: this.querySelector(this.selectors.pagination),
      },
      instances: {
        slider: null,
      },
      options: {
        slider: {
          autoHeight: true,
          spaceBetween: 20,
          loop: true,
          slidesPerView: 1,
          navigation: {
            prevEl: this.querySelector('.swiper-arrow--prev'),
            nextEl: this.querySelector('.swiper-arrow--next'),
          },
          pagination: {
            el: this.querySelector(this.selectors.pagination),
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' +
                '<img class="donut-dot donut-dot--inactive" src="' + donutDot + '" alt="" width="30" height="30">' +
                '<img class="donut-dot donut-dot--active" src="' + donutDotActive + '" alt="" width="30" height="30">' +
                '</span>';
            },
          },
          breakpoints: {
            750: {
              autoHeight: false,
              slidesPerView: 2,
              spaceBetween: 24,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        },
      },
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.settings.elements.slider) {
      this.settings.instances.slider = new Swiper(
        this.settings.elements.slider,
        this.settings.options.slider,
      );

      this.initReadMore();
    }
  }

  initReadMore() {
    this.querySelectorAll(this.selectors.readMore).forEach((container) => {
      const button = container.querySelector(this.selectors.readMoreButton);
      const content = container.querySelector(this.selectors.readMoreContent);

      if (!button || !content) return;

      requestAnimationFrame(() => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        button.hidden = !isMobile || content.scrollHeight <= content.clientHeight;
      });

      button.addEventListener('click', () => {
        container.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        button.hidden = true;
        this.settings.instances.slider?.update();
        this.settings.instances.slider?.updateAutoHeight();
      });
    });
  }
}

customElements.define('testimonials-new-slider', TestimonialsNewSlider);
